import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import WithoutDriverForm from './WithoutDriverForm';
import { useLocation } from 'react-router-dom';
import WithDriverForm from './WithDriverForm';
import AirportTransferForm from './AirportTransferForm';

const DetailSewa = forwardRef(
  (
    {
      prevPage,
      nextPage,
      orderData,
      setOrderData,
      vehicleInput,
      setVehicleInput,
      selectedCar,
      setSelectedCar,
      startRentDate,
      setStartRentDate,
      endRentDate,
      setEndRentDate,
      deliveryLocation,
      setDeliveryLocation,
      returnLocation,
      setReturnLocation,
      isOrderConfirmation,
      allVehicle,
      selectedOvertime,
      setSelectedOvertime,
      selectedPaymentType,
      setSelectedPaymentType,
      // with driver//
      durationRent,
      setDurationRent,
      dayDuration,
      setDayDuration,
      allZonesList,
      // airport transfer//
      isSwitch,
      setIsSwitch,
      // shuttleData,
      rentalLocation,
      setRentalLocation,
      selectedAdditionalItem,
      setSelectedAdditionalItem,
      luggageAirport,
      setLuggageAirport,
      passengersAirport,
      setPassengersAirport,
      startLocation,
      setStartLocation,
      endLocation,
      setEndLocation,
      locationData,
      setLocationData,
      isMeetAndGreetBoardRequire,
      setIsMeetAndGreetBoardRequire,
      ktpImageLink,
      uploadImageAction,
    },
    ref,
  ) => {
    const grandChildRef = useRef(null);
    const location = useLocation();

    const pathName = location.pathname.split('/').filter((item) => item !== '')[0];

    useImperativeHandle(ref, () => ({
      callGrandChild() {
        if (grandChildRef.current) {
          grandChildRef.current.actionInGrandChild();
        }
      },
    }));

    return (
      <div className="detail-sewa">
        <div className="detail-sewa__detail-sewa-form">
          {pathName !== 'with-driver' ? (
            <span className="detail-sewa__detail-sewa-form__title">
              <h2>Detail Sewa</h2>
            </span>
          ) : null}

          {pathName === 'without-driver' ? (
            <WithoutDriverForm
              // prevPage={prevPage}
              nextPage={nextPage}
              orderData={orderData}
              setOrderData={setOrderData}
              vehicleInput={vehicleInput}
              setVehicleInput={setVehicleInput}
              selectedCar={selectedCar}
              setSelectedCar={setSelectedCar}
              startRentDate={startRentDate}
              setStartRentDate={setStartRentDate}
              endRentDate={endRentDate}
              setEndRentDate={setEndRentDate}
              deliveryLocation={deliveryLocation}
              setDeliveryLocation={setDeliveryLocation}
              returnLocation={returnLocation}
              setReturnLocation={setReturnLocation}
              allVehicle={allVehicle}
              selectedOvertime={selectedOvertime}
              setSelectedOvertime={setSelectedOvertime}
              selectedPaymentType={selectedPaymentType}
              setSelectedPaymentType={setSelectedPaymentType}
              isOrderConfirmation={isOrderConfirmation}
              rentalLocation={rentalLocation}
              setRentalLocation={setRentalLocation}
              selectedAdditionalItem={selectedAdditionalItem}
              setSelectedAdditionalItem={setSelectedAdditionalItem}
              // descriptionAdditionalItem={descriptionAdditionalItem}
              // setDescriptionAdditionalItem={setDescriptionAdditionalItem}
              ref={grandChildRef}
              isMeetAndGreetBoardRequire={isMeetAndGreetBoardRequire}
              setIsMeetAndGreetBoardRequire={setIsMeetAndGreetBoardRequire}
            />
          ) : pathName === 'with-driver' ? (
            <WithDriverForm
              prevPage={prevPage}
              nextPage={nextPage}
              allVehicle={allVehicle}
              selectedCar={selectedCar}
              setSelectedCar={setSelectedCar}
              vehicleInput={vehicleInput}
              setVehicleInput={setVehicleInput}
              orderData={orderData}
              setOrderData={setOrderData}
              startRentDate={startRentDate}
              setStartRentDate={setStartRentDate}
              durationRent={durationRent}
              setDurationRent={setDurationRent}
              selectedOvertime={selectedOvertime}
              setSelectedOvertime={setSelectedOvertime}
              selectedPaymentType={selectedPaymentType}
              setSelectedPaymentType={setSelectedPaymentType}
              isOrderConfirmation={isOrderConfirmation}
              dayDuration={dayDuration}
              setDayDuration={setDayDuration}
              allZonesList={allZonesList}
              rentalLocation={rentalLocation}
              setRentalLocation={setRentalLocation}
              selectedAdditionalItem={selectedAdditionalItem}
              setSelectedAdditionalItem={setSelectedAdditionalItem}
              // descriptionAdditionalItem={descriptionAdditionalItem}
              // setDescriptionAdditionalItem={setDescriptionAdditionalItem}
              ref={grandChildRef}
              isMeetAndGreetBoardRequire={isMeetAndGreetBoardRequire}
              setIsMeetAndGreetBoardRequire={setIsMeetAndGreetBoardRequire}
            />
          ) : pathName === 'airport-transfer' ? (
            <AirportTransferForm
              // prevPage={prevPage}
              nextPage={nextPage}
              orderData={orderData}
              setOrderData={setOrderData}
              deliveryLocation={deliveryLocation}
              setDeliveryLocation={setDeliveryLocation}
              returnLocation={returnLocation}
              setReturnLocation={setReturnLocation}
              isOrderConfirmation={isOrderConfirmation}
              startRentDate={startRentDate}
              setStartRentDate={setStartRentDate}
              setEndRentDate={setEndRentDate}
              allVehicle={allVehicle}
              selectedCar={selectedCar}
              setSelectedCar={setSelectedCar}
              vehicleInput={vehicleInput}
              setVehicleInput={setVehicleInput}
              isSwitch={isSwitch}
              setIsSwitch={setIsSwitch}
              // shuttleData={shuttleData}
              rentalLocation={rentalLocation}
              setRentalLocation={setRentalLocation}
              ref={grandChildRef}
              luggageAirport={luggageAirport}
              setLuggageAirport={setLuggageAirport}
              passengersAirport={passengersAirport}
              setPassengersAirport={setPassengersAirport}
              startLocation={startLocation}
              setStartLocation={setStartLocation}
              endLocation={endLocation}
              setEndLocation={setEndLocation}
              locationData={locationData}
              setLocationData={setLocationData}
              selectedAdditionalItem={selectedAdditionalItem}
              setSelectedAdditionalItem={setSelectedAdditionalItem}
              isMeetAndGreetBoardRequire={isMeetAndGreetBoardRequire}
              setIsMeetAndGreetBoardRequire={setIsMeetAndGreetBoardRequire}
              ktpImageLink={ktpImageLink}
              uploadImageAction={uploadImageAction}
            />
          ) : null}
        </div>
      </div>
    );
  },
);

DetailSewa.displayName = 'Detail Sewa';
export default DetailSewa;
